import MasterService from "./MasterService";

const ConfigPanelService = {
    ...MasterService,
    getVehicleAge(params: object){
        return this.post('/config/getVehicleAge',params);
    },
    
    saveVehicleAge(params: object) {
        return this.post('/config/saveVehicleAge', params)
    },
    
    getBasicPremium(params: object) {
        return this.post('/config/getBasicPremium', params)
    },
    saveBasicPremium(params: object) {
        return this.post('/config/saveBasicPremium', params)
    },
    deleteBasicPremium(params: object) {
        return this.post('/config/deleteBasicPremium', params)
    },
    getAdminFee(params: object) {
        return this.post('/config/getAdminFee', params)
    },
    saveAdminFee(params: object) {
        return this.post('/config/saveAdminFee', params)
    },
    getLoadingRate(params: object) {
        return this.post('/config/getLoadingRate', params)
    },
    saveLoadingRate(params: object) {
        return this.post('/config/saveLoadingRate', params)
    },
    getAddonList(params: object) {
        return this.post('/config/addonList', params)
    },
    updateAddonCode(params: object) {
        return this.post('/addon/updateAddonCode', params)
    },
    updateAddonsRate(params: object) {
        return this.post('/addon/updateAddonsRate', params)
    },
    fetchAddonsRate(params: object) {
        return this.post('/addon/fetchAddonsRate', params)
    },
    deleteAddonRate(params: object) {
        return this.post('/addon/deleteAddonRate', params)
    },
    
    getAgentCommission(params: object) {
        return this.post('/config/getAgentCommission', params)
    },
    
    saveAgentCommission(params: object) {
        return this.post('/config/saveAgentCommission', params)
    },
    deleteAgentCommission(params: object) {
        return this.post('/config/deleteAgentCommission', params)
    },
    getWpcDays(params: object) {
        return this.post('/xendit/get-wpc-days',params);
    },
    saveWpcDays(params: object) {
        return this.post('/xendit/save-wpc-days',params);
    },
    getXenditFee(params: object) {
        return this.post('/xendit/get-xendit-fee',params);
    },
    saveXenditFee(params: object) {
        return this.post('/xendit/save-xendit-fee',params);
    },
    saveBranchConfig(params: object) {
        return this.post('/config/saveBranchConfig',params);
    },
    getBranchConfig(params: object) {
        return this.post('/config/getBranchConfig',params);
    },
    deleteBranchConfig(params: object) {
        return this.post('/config/deleteBranchConfig',params);
    },
    getMultiTenure(params: object) {
        return this.post('/config/getMultiTenure',params);
    },
    saveMultiTenure(params: object) {
        return this.post('/config/saveMultiTenure',params);
    }
}

export default ConfigPanelService
